export default {
	title: "",
	subtitle: "Subscription with BRL Card",
  path: "subscription_brl_card",
  paragraph: 'Basically, using the subscription with a card is very similar to the "Credit card transactions Brazil" and "Credit card transactions Brazil - JWT for DDC" sections.',
  hyperlink: {
    linkPath: "/static/SubscriptionBRSample.zip",
    linkText: "Download sample page"
  },
  request: {
    method: "POST",
		endpoint: "/subscriptions",
		payloads: [
      {
        "title": "Create a Subscription using credit/debit card",
        "content": {
          "subscription": {
            "cycles": 12,
            "frequency": "month",
            "value": "100",
            "currency": "BRL",
            "description": "some description",
            "subject_id": "your subject_id",
            "to_bank_account_id": "your to_bank_account_id",
            "from_card": {
              "card_type": "credit",
              "card_number": "4000000000001000",
              "card_expiration_date": "09/2029",
              "card_security_code": "123",
              "card_brand": "Visa",
              "fullname": "Jose Silva",
              "threeds": {
                "softDescriptor": "FacilitaPay",
                "httpAcceptBrowserValue": "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8",
                "httpBrowserLanguage": "en-US",
                "httpBrowserJavaEnabled": "false",
                "httpBrowserJavaScriptEnabled": "true",
                "httpBrowserColorDepth": "24",
                "httpBrowserScreenHeight": "969",
                "httpBrowserScreenWidth": "1250",
                "httpBrowserTimeDifference": "240",
                "userAgentBrowserValue": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/138.0.0.0 Safari/537.36",
                "ipAddress": "127.0.0.1",
                "challengeWindowSize": "250x400"
              },
            }
          }
        }
      }
    ],
		responses: {
      "data": {
        "canceled_at": null,
        "canceled_by_payer": null,
        "canceled_reason": null,
        "completed_at": null,
        "currency": "BRL",
        "cycles": 12,
        "description": "some description",
        "free_days": 0,
        "frequency": "month",
        "from_bank_account_id": null,
        "id": "899758d4-145a-4481-9791-d28b254373cc",
        "inserted_at": "2025-09-01T15:47:20.803645",
        "payer_bank_account_id": null,
        "payer_card_id": "df5d14f1-39b9-498d-bc20-e09b97e09281",
        "payment_method": "card",
        "status": "active",
        "subject_id": "b009558e-16b0-45dd-9bb7-7edea3d7a5cf",
        "to_bank_account_id": "f29b519d-0b54-42b7-af09-6ad78f0a889a",
        "total_retry_attempts": 0,
        "trial_days": 0,
        "updated_at": "2025-09-01T15:47:20.874607",
        "value": "100"
      }
    }
	},
	parameterPayload: [
    {
      name: "subscription",
      type: "object",
      required: true,
      description: "Subscription data containing at least the following required values:"
    },
    {
      name: "subscription.value",
      type: "string",
      required: true,
      description: 'Total amount to be charged. Only numbers with exponent size 2 are allowed. (e.g.: "12.34").'
    },
    {
      name: "subscription.currency",
      type: "string",
      required: true,
      description: "Defines the subscription currency in ISO 4217 format, currently the only accepted value is “BRL”."
    },
    {
      name: "subscription.frequency",
      type: "string",
      required: true,
      description: 'Defines how often the subscription will be charged. Possible values are: "day", "week", "month", "quarter", "semester", "year".'
    },
    {
      name: "subscription.cycles",
      type: "object",
      required: true,
      description: "Number of cycles the subscription will have. For example, if the frequency is “month” and the cycles is 12, the subscription will last for 12 months."
    },
    {
      name: "subscription.trial_days",
      type: "object",
      required: false,
      description: "Defines a trial period before the first charge. After the trial period ends, future charges always respect the original subscription date."
    },
    {
      name: "subscription.free_days",
      type: "object",
      required: false,
      description: "Defines a grace period before the first charge. After the grace period ends, future charges will occur on the date the first charge occurred."
    },
    {
      name: "subscription.total_retry_attempts",
      type: "object",
      required: false,
      description: "Defines how many retry attempts will be made if charges fail, except for the first invoice. The default value is zero and it can range from zero to three."
    },
    {
      name: "subscription.description",
      type: "object",
      required: false,
      description: "A brief description of the subscription."
    },
    {
      name: "subscription.to_bank_account_id",
      type: "string",
      required: true,
      description: "Partner internal or external international bank account ID"
    },
    {
      name: "subscription.subject_id",
      type: "string",
      required: true,
      description: "The ID of the person or company involved in this subscription."
    },
    {
      name: "subscription.meta",
      type: "object",
      required: false,
      description: "Any metadata you want to add to the subscription to help you identify it later."
    },
    {
      name: "subscription.from_card",
      type: "object",
      required: true,
      description: ""
    },
    {
      name: "subscription.from_card.card_number",
      type: "string",
      required: true,
      description: "The card number without spaces"
    },
    {
      name: "subscription.from_card.card_expiration_date",
      type: "string",
      required: true,
      description: "Card expiration date in MM/YYYY format"
    },
    {
      name: "subscription.from_card.card_brand",
      type: "string",
      required: true,
      description: 'Card brand, such as "visa", "mastercard", or "elo"'
    },
    {
      name: "subscription.from_card.card_security_code",
      type: "string",
      required: true,
			description: "3-digit card security code"
    },
    {
      name: "subscription.from_card.fullname",
      type: "string",
      required: true,
      description: "Cardholder's full name"
    },
    {
      name: "subscription.from_card.threeds",
      type: "object",
      required: true,
      description: "Data containing at least the following required values:"
    },
    {
      name: "subscription.from_card.threeds.softDescriptor",
      type: "string",
      required: false,
      description: `A short identifier (maximum of 13 characters) for the merchant that appears on the buyer’s credit card statement. All non-alphanumeric characters are removed, and the resulting value is concatenated with “*facilitapay”. If the descriptor exceeds 13 characters, it will be truncated. Examples: “airbnb” → “airbnb*facili”, “americanairlines” → “americanairli”`
    },
    {
      name: "subscription.from_card.threeds.httpAcceptBrowserValue",
      type: "string",
      required: true,
      description: "Value of the Accept Header of the Customer's browser."
    },
    {
      name: "subscription.from_card.threeds.httpBrowserLanguage",
      type: "string",
      required: true,
      description: "Customer's browser language according to https://www.techonthenet.com/js/language_tags.php"
    },
    {
      name: "subscription.from_card.threeds.httpBrowserJavaEnabled",
      type: "string",
      required: true,
      description: 'If Java is enabled on customer browser.\nOptions: "true", "false"'
    },
    {
      name: "subscription.from_card.threeds.httpBrowserJavaScriptEnabled",
      type: "string",
      required: true,
      description: 'If JavaScript is enabled on customer browser.\nOptions: "true", "false"'
    },
    {
      name: "subscription.from_card.threeds.httpBrowserColorDepth",
      type: "string",
      required: true,
      description: "Number of bits used to display images."
    },
    {
      name: "subscription.from_card.threeds.httpBrowserScreenHeight",
      type: "string",
      required: true,
      description: "Height of the Customer's screen resolution."
    },
    {
      name: "subscription.from_card.threeds.httpBrowserScreenWidth",
      type: "string",
      required: true,
      description: "Width of the Customer screen resolution."
    },
    {
      name: "subscription.from_card.threeds.httpBrowserTimeDifference",
      type: "string",
      required: true,
      description: "Difference in minutes between GMT time and that of the Customer's browser."
    },
    {
      name: "subscription.from_card.threeds.userAgentBrowserValue",
      type: "string",
      required: true,
      description: "The exact value of the User Agent Header."
    },
    {
      name: "subscription.from_card.threeds.ipAddress",
      type: "string",
      required: true,
      description: "It is the IP address of the Customer's device."
    },
    {
      name: "subscription.from_card.threeds.challengeWindowSize",
      type: "string",
      required: true,
      description: 'The size of the challenge window displayed to the shopper.\nOptions: "fullPage", "250x400", "390x400", "500x600", "600x400".'
    },
    {
      name: "subscription.from_card.meta.df_reference_id",
      type: "string",
      required: true,
      description: "Session ID generated after the DDC is completed."
    },
    {
      name: "subscription.from_card.meta.mcc",
      type: "string",
      required: true,
      description: 'Dynamic MCC. If you have multiple merchant category codes, the MCC lets you send a different merchant category code per subscription.\nOptions: "8999", "5045", "4722", "8299", "5947", "5065", "7372"'
    },
  ],
  troubleshooting: {
    title: 'Common mistakes',
    messages: [
       {
        description: 'Do not send the full credit card name',
        code: {
              "errors": {
                  "fullname": [
                      "can't be blank"
                  ]
              }
          },
        solution: 'Please provide full credit card name'
      },
      {
        description: 'Card number with less than 13 character(s)',
        code: {
              "errors": {
                  "card_number": [
                      "should be at least 13 character(s)"
                  ]
              }
          },
        solution: 'Please provide a valid credit card number'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Subscription/SubscriptionBRLCard.js